module.exports = __webpack_public_path__ + "static/media/imageFileIcon.25a11474.svg";